// extracted by mini-css-extract-plugin
export var modal = "_u6-0";
export var table = "_u6-1";